document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('ftb-restock-modal');

  if (!modal) return;

  const sizePill = modal.querySelector('#ftb-restock-size-pill');
  const productInput = modal.querySelector('#ftb-restock-product');
  const variantInput = modal.querySelector('#ftb-restock-variant');
  const variantIdInput = modal.querySelector('#ftb-restock-variant-id');
  const form = modal.querySelector('.ftb-restock-modal__form');
  const successScreen = modal.querySelector(
    '.ftb-restock-modal__success'
  );
  const closeButtons = modal.querySelectorAll(
    '[data-ftb-restock-close]'
  );

  let previousActiveElement = null;

  window.openFTBRestockModal = function ({
    size = 'XL',
    productTitle = '',
    variantTitle = '',
    variantId = ''
  } = {}) {
    previousActiveElement = document.activeElement;

    if (sizePill) {
      sizePill.textContent = size;
      sizePill.setAttribute(
        'aria-label',
        `Selected size ${size}`
      );
    }

    if (productInput) {
      productInput.value = productTitle;
    }

    if (variantInput) {
      variantInput.value = variantTitle || size;
    }

    if (variantIdInput) {
      variantIdInput.value = variantId;
    }

    if (form) {
      form.hidden = false;
    }

    if (successScreen) {
      successScreen.hidden = true;
    }

    modal.classList.add('active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    const emailInput = modal.querySelector(
      '#ftb-restock-email'
    );

    window.setTimeout(() => {
      emailInput?.focus();
    }, 100);
  };

  function closeModal() {
    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    if (
      previousActiveElement &&
      typeof previousActiveElement.focus === 'function'
    ) {
      previousActiveElement.focus();
    }
  }

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });
document.addEventListener('click', (event) => {
  const soldOutOption = event.target.closest(
    '.variant-option__button-label'
  );

  if (!soldOutOption) return;

  const input = soldOutOption.querySelector(
    'input[data-option-available="false"]'
  );

  if (!input) return;

  event.preventDefault();
  event.stopPropagation();

  const size =
    input.dataset.optionValue ||
    input.value ||
    'Unavailable';

  const variantId =
    input.dataset.variantId || '';

  const variantTitle =
    input.getAttribute('aria-label') ||
    size;

  const productTitle =
    document.querySelector('h1')?.textContent?.trim() || '';

  window.openFTBRestockModal({
    size,
    productTitle,
    variantTitle,
    variantId
  });
});
  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Escape' &&
      modal.classList.contains('active')
    ) {
      closeModal();
    }
  });
});